import React from "react";
import AppointmentsTableCard from "../../../components/Files/AppointmentsTableCard";
import DashboardChartCard from "../../../components/Files/DashboardChartCard";
import { CalendarCheck, DollarSign } from "lucide-react";

interface AppointmentsTabProps {
  activeTab: string;
  appointmentsData?: any[];
  serviceAppointmentsData?: any[];
  todayAppointments?: any[];
}

const AppointmentsTab: React.FC<AppointmentsTabProps> = ({
  activeTab,
  appointmentsData = [],
  serviceAppointmentsData = [],
  todayAppointments = [],
}) => {
  if (activeTab !== "appointments") return null;

  return (
    <>
      <h3 className="text-2xl font-semibold text-gray-800 mb-4 border-b-4 border-purple-500 pb-2">
        Appointments
      </h3>

      <div className="mt-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Veterinarian Appointments Graph */}
          <DashboardChartCard
            title="Veterinarian Appointments"
            icon={<CalendarCheck className="w-5 h-5 text-blue-500" />}
            color="blue"
            data={appointmentsData}
            xKey="day"
            yKey="appointments"
            navigateTo="/appointments"
          />

          {/* Veterinarian Revenue Graph */}
          <DashboardChartCard
            title="Veterinarian Revenue"
            icon={<DollarSign className="w-5 h-5 text-green-500" />}
            color="green"
            data={appointmentsData}
            xKey="day"
            yKey="revenue"
            navigateTo="/appointments"
          />

          {/* Service Orders Graph */}
          <DashboardChartCard
            title="Service Orders"
            icon={<CalendarCheck className="w-5 h-5 text-purple-500" />}
            color="purple"
            data={serviceAppointmentsData}
            xKey="day"
            yKey="serviceOrders"
            navigateTo="/service-orders"
          />

          {/* Service Revenue Graph */}
          <DashboardChartCard
            title="Service Revenue"
            icon={<DollarSign className="w-5 h-5 text-orange-500" />}
            color="orange"
            data={serviceAppointmentsData}
            xKey="day"
            yKey="revenue"
            navigateTo="/service-orders"
          />
        </div>
      </div>

      {/* Appointments Table */}
      <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-5">
        <AppointmentsTableCard
          title="Today's Appointments"
          data={todayAppointments}
          navigatePath="/appointments"
          columns={[
            { key: "reason", label: "Pet Name" },
            {
              key: "owner",
              label: "Owner",
              render: (item) =>
                item.participants && item.participants.length > 1
                  ? item.participants[1].participant_info.name
                  : "Unknown",
            },
            {
              key: "status",
              label: "Status",
              render: (item) => item.consult_status?.name || "Unknown",
              isStatus: true,
            },
          ]}
          statusColorMap={{
            Unpaid: "bg-gray-100 text-gray-700",
            Pending: "bg-yellow-100 text-yellow-800",
            InProgress: "bg-blue-100 text-blue-800",
            Cancelled: "bg-red-100 text-red-800",
            Completed: "bg-green-100 text-green-800",
            Rescheduled: "bg-purple-100 text-purple-800",
            NoShow: "bg-orange-100 text-orange-800",
          }}
        />
      </div>
    </>
  );
};

export default AppointmentsTab;
